import React from 'react';
import { Typography, Box, Stack, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import { TRANSACTION_TYPES_CONFIG } from './TransactionConfig';

export default function TransferDocumentation() {

    const types = Object.keys(TRANSACTION_TYPES_CONFIG);

    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5 }}>
            {types.map((type) => {
                const cfg = TRANSACTION_TYPES_CONFIG[type];

                return (
                    <Box
                        key={type}
                        sx={{
                            borderRadius: 1,
                            border: '1px solid #e0e0e0',
                            bgcolor: '#fff',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {/* HEADER */}
                        <Box sx={{ px: 1, py: 0.5, bgcolor: '#fafafa', borderBottom: '1px solid #eee' }}>
                            <Typography sx={{ fontWeight: 900, color: cfg.color, fontSize: '0.6rem', letterSpacing: '0.05rem' }}>
                                {cfg.label.toUpperCase()}
                            </Typography>
                        </Box>

                        <Stack divider={<Divider />} sx={{ flexGrow: 1 }}>
                            {/* PRODUCER */}
                            <Box sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ minWidth: 60 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.55rem' }}>
                                        PRODUCER
                                    </Typography>
                                </Box>
                                {cfg.pField ? (
                                    <CheckCircleIcon sx={{ fontSize: 14, color: '#4caf50' }} />
                                ) : (
                                    <BlockIcon sx={{ fontSize: 14, color: '#e0e0e0' }} />
                                )}
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 500, color: cfg.pField ? 'text.primary' : 'text.disabled' }}>
                                        {cfg.pLabel}
                                    </Typography>
                                </Box>
                                {cfg.pField && (
                                    <Typography variant="caption" sx={{ fontSize: '0.55rem', fontWeight: 700, fontFamily: 'monospace', bgcolor: '#f5f5f5', px: 0.5, borderRadius: 0.5, border: '1px solid #ddd' }}>
                                        {cfg.pField}
                                    </Typography>
                                )}
                            </Box>

                            {/* OPERATOR */}
                            <Box sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ minWidth: 60 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.55rem' }}>
                                        OPERATOR
                                    </Typography>
                                </Box>
                                {cfg.oField ? (
                                    <CheckCircleIcon sx={{ fontSize: 14, color: '#4caf50' }} />
                                ) : (
                                    <BlockIcon sx={{ fontSize: 14, color: '#e0e0e0' }} />
                                )}
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 500, color: cfg.oField ? 'text.primary' : 'text.disabled' }}>
                                        {cfg.oLabel}
                                    </Typography>
                                </Box>
                                {cfg.oField && (
                                    <Typography variant="caption" sx={{ fontSize: '0.55rem', fontWeight: 700, fontFamily: 'monospace', bgcolor: '#f5f5f5', px: 0.5, borderRadius: 0.5, border: '1px solid #ddd' }}>
                                        {cfg.oField}
                                    </Typography>
                                )}
                            </Box>
                        </Stack>
                    </Box>
                );
            })}
        </Box>
    );
}